import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, combineLatest, Subscription } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { CustomOhgarItemTabData, CustomOhgarTabsData } from './custom-ohgar-tabs.model';
import {
  CustomCmsEventService
} from "src/app/spartacus/features/tracking/custom-events/checkout/cms/custom-cms-event.service";

@Component({
  selector: 'app-custom-ohgar-tabs',
  templateUrl: './custom-ohgar-tabs.component.html',
  styleUrls: ['./custom-ohgar-tabs.component.scss'],
  standalone: false
})
export class CustomOhgarTabsComponent implements AfterViewInit, OnDestroy {
  active = 1;
  xDown = null;
  xDiff = null;
  protected subscriptions: Subscription = new Subscription();

  constructor(
    protected componentData: CmsComponentData<CustomOhgarTabsData>,
    protected cmsService: CmsService,
    protected customCmsEventService: CustomCmsEventService
  ) {
  }

  data$: Observable<CustomOhgarTabsData> = this.componentData.data$.pipe(map(component => component));

  items$: Observable<CustomOhgarItemTabData[]> = this.data$.pipe(
    switchMap(data =>
      combineLatest(
        data.items?.trim().split(' ').map(
          (codes: any) => this.cmsService.getComponentData(codes).pipe(
            map(tab => tab)
          )
        )
      )
    )
  );

  startMove(event: TouchEvent): void {
    const touch = event.touches[0] || event.changedTouches[0];
    this.xDown = touch.clientX;
  }

  touchMove(event: TouchEvent, itemsLength: number): void {
    if (!this.xDown) {
      return;
    }

    const touch = event.touches[0] || event.changedTouches[0];

    const xUp = touch.clientX;
    this.xDiff = this.xDown - xUp;

    if (Math.abs(this.xDiff) !== 0) {
      if (this.xDiff > 2) {
        this.active = this.active < itemsLength ? this.active + 1 : this.active;
      } else if (this.xDiff < -2) {
        this.active = this.active > 1 ? this.active - 1 : 1;
      }
    }

    // Reset values.
    this.xDown = null;
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.items$.pipe(take(1)).subscribe(items => {
        this.customCmsEventService.dispatchViewPromotionEvent(items);
      })
    )
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
